import options from './selector.component';

export default {
    selector: 'dtFolderSelector',
    options
};



// WEBPACK FOOTER //
// ./app/common/tree/folder-selector/index.js